import { CompanyUserEdit } from "@/features/company/pages/CompanyUserEdit";
import { FC } from "react";

const CompanyUserEditPage: FC = () => {
  return <CompanyUserEdit />;
};

export default CompanyUserEditPage;
